import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { useTranslator } from '@bluebeam/react-i18n';
import { GeneralIcons } from '@bluebeam/react-skyline-art';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
/**
 * Search is a type of **molecule** allow user to input text and find item(s) relate to it.
 */
const Search = forwardRef(({ className, height, id, isDisabled, isError, maxLength, onChange, placeholder, value, width, ...rest }, outerRef) => {
    const dataAttributes = useDataAttributes(rest);
    const [showClear, setShowClear] = useState(value ? true : false);
    const searchInputRef = useRef(null);
    useImperativeHandle(outerRef, () => ({
        focus() {
            searchInputRef.current.focus();
        },
    }), []);
    const { translate } = useTranslator(['local']);
    const handleOnClear = () => {
        onChange('');
        setShowClear(false);
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    };
    const handleKeyDown = (e) => {
        if (e.code === 'Enter' || e.code === 'Space') {
            handleOnClear();
        }
    };
    return (_jsx("div", { className: buildClassName('border-darker-gray rounded-lg border border-solid bg-white', 'group flex h-8 content-between items-center', 'focus-within:border-primary-blue focus-within:shadow-[0_0_0_1px_rgba(0,116,204)]', {
            'border-light-gray': isDisabled,
            'border-alerts-error-red shadow-[0_0_0_1px_rgba(167,22,41)]': isError && !isDisabled,
            'focus-within:border-alerts-error-red focus-within:shadow-[0_0_0_1px_rgba(167,22,41)]': isError,
            'h-8': height === '32px',
            'h-10': height === '40px',
        }, className), id: id, style: { width: width ?? 267 }, ...dataAttributes, children: _jsxs("div", { className: "flex h-8 w-full items-center", children: [_jsx(GeneralIcons.SearchIcon, { className: buildClassName('ml-1 shrink-0', { 'text-light-gray': isDisabled }, { 'text-darker-gray': !isDisabled }), size: "24px" }), _jsx("input", { className: buildClassName('m-auto w-full rounded-sm border-none pl-1 text-sm outline-none', { 'text-light-gray placeholder-light-gray bg-white': isDisabled }, { 'placeholder-darker-gray text-black ': !isDisabled }), disabled: isDisabled, maxLength: maxLength ?? undefined, onChange: (event) => {
                        const activeSearchText = event.target.value.trimStart();
                        setShowClear(Boolean(activeSearchText));
                        onChange(activeSearchText);
                    }, placeholder: placeholder ?? 'Search', ref: searchInputRef, value: value }), showClear && (_jsx("div", { "aria-label": translate('local:clearSearch'), className: buildClassName('flex cursor-pointer border-0 bg-white', 'm-auto items-center justify-center pr-2'), onClick: (e) => {
                        e.stopPropagation();
                        handleOnClear();
                    }, onKeyDown: (e) => {
                        e.stopPropagation();
                        handleKeyDown(e);
                    }, role: "button", tabIndex: 0, children: _jsx(GeneralIcons.XCircledFilledIcon, { className: "text-[#898686]", size: "24px" }) }))] }) }));
});
export default Search;
//# sourceMappingURL=Search.js.map